import { ConnectionName } from "@redotech/redo-integrations-configs/connections/connection-types";
import {
  HttpMetadata,
  HttpSecret,
} from "@redotech/redo-integrations-configs/connections/http.connection-type";
import { ConnectionKind } from "@redotech/redo-integrations-core/connection-type/connection-kind";
import * as z from "zod";
import { ConnectionView } from "./connection";

export const createConnection = {
  name: "createConnection" as const,
  input: z.discriminatedUnion("type", [
    z.object({
      type: z.literal(ConnectionKind.Http),
      name: ConnectionName,
      metadata: HttpMetadata,
      secret: HttpSecret,
    }),
  ]),
  output: ConnectionView,
};
